module.exports = __webpack_public_path__ + "static/carou1-6b529ce267ade1a49b9589de71859a2f.jpg";